module.exports = __webpack_public_path__ + "static/media/(V)_MG_6034_-_Pro-Natura_-_Moda_Bebe.341c0fb0.jpg";